import {
    IconDefinition,
    IconPack,
    dom,
    library,
} from '@fortawesome/fontawesome-svg-core'
import { far } from '@fortawesome/free-regular-svg-icons'
import {
    faExclamationCircle,
    faExclamationTriangle,
    fas,
} from '@fortawesome/free-solid-svg-icons'
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'

library.add(
    fas as IconPack,
    far as IconPack,
    faExclamationCircle as IconDefinition,
    faExclamationTriangle as IconDefinition
)
dom.watch()

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
)
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
